<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="code" v-model="form.code" placeholder="资产编码"
                                    @update:modelValue="(value) => handleModelValueUpdate('code', value)"/>
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="name" v-model="form.name" placeholder="资产名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
                        <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" :options="userList" v-model="form.chargerId" id="chargerId" placeholder="保管人"
                                     @update:modelValue="(value) => handleModelValueUpdate('chargerId', value)"/>
                        <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" :options="statusList" v-model="form.status" id="chargerId" placeholder="资产状态"
                                     @update:modelValue="(value) => handleModelValueUpdate('status', value)"/>
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="导入资产" @click="onClick" secondary />
                        <ButtonField text="下载模版" primary @click="download"/>
                        <ButtonField text="创建资产" @click="add" secondary />
                    </div>
                </div>
            </form>
        </div>
        <Tablelist style="margin-top: 1rem"
                   :showCheckbox="false"
                   :list="list"
                   :columns="tableColumns"
                   :totalSize="totalSize"
                   :totalPages="totalPages"
                   :pageNum="pageNum"
                   :pageSize="pageSize"
                   @action="handleAction"
                   @page-change="onChange"
        />
        <AddIndex v-if="addShow" :visible="addShow" :key="editKey" @closed="handleModalClosed('add')" />
        <EditIndex v-if="editShow" :visible="editShow" :key="editKey" @closed="handleModalClosed('edit')"/>
    </div>
</template>
<script>
import { fetchList, remove } from "../api/list";
import { mapActions, mapGetters, mapState } from "vuex";
import request from "@/api/request";
import AddIndex from './add.vue'
import EditIndex from './edit.vue'
function upload(data) {
  return request({
    url: "/model-analysis/asset/material/import",
    method: "post",
    data,
  });
}

export default {
    components: {AddIndex,EditIndex},
  data() {
    return {
      form: {},
      list: [],
      loading: false,
        totalSize: 0,
        totalPages: 0,
        pageNum: 1,
        pageSize: 10,
      uploading: false,
      addShow:false,
      editShow:false,
      editKey: 0,
      tableColumns: [
        {
            key: 'code',
            title: '资产编号',
            field: 'code',
            infotype: 'text'
        },
        {
            key: 'name',
            title: '资产名称',
            field: 'name',
            infotype: 'text',
        },
        {
            key: 'brand',
            title: '品牌',
            field: 'brand',
            infotype: 'text',
        },
        {
            key: 'specification',
            title: '规格型号',
            field: 'specification',
            infotype: 'text',
        },
        {
            key: 'unit',
            title: '单位',
            field: 'unit',
            infotype: 'text',
        },
        {
            key: 'price',
            title: '单价',
            field: 'price',
            infotype: 'text',
        },
        {
            key: 'status',
            title: '资产状态',
            field: 'status',
            infotype: 'text',
        },
        {
            key: 'createAt',
            title: '入库时间',
            field: 'createAt',
            infotype: 'text',
        },
        {
            key: 'charger',
            title: '保管人',
            field: 'charger',
            infotype: 'text',
        },
        {
            key: 'actions',
            title: '操作',
            render: {
                view: false,
                edit: true,
                delete: true
            }
        }
    ],
    };
  },
  mounted() {
    this.getUserList();
    this.getList();
  },
  computed: {
    ...mapState("userSelector", ["userList"]),
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("AssetMaterialStatus");
    },
  },
  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
      handleModalClosed(type) {
          if (type === 'add') {
              this.addShow = false;
          } else if (type === 'edit') {
              this.editShow = false;
          }
      },
    add(){
      console.log("this.addShow:::",this.addShow)
      this.addShow = true
      this.editShow = false
      this.editKey += 1;
    },
    handleAction(actionInfo) {
      const { type, item } = actionInfo;
      switch(type) {
          case 'edit':
              this.edit(item);
              break;
          case 'delete':
              this.deleteText(item);
              break;
      }
    },
    getMoney(money){
      if (typeof money === "number") {
          return money.toLocaleString();
      } else {
          return money;
      }
    },
    onClick() {
      this.$refs.upload.click();
    },
    onFileChange(e) {
      const files = e.target.files;
      const data = new FormData();
      if (files.length === 0) {
        return;
      }
      data.append("file", files[0]);

      this.uploading = true;

      upload(data)
        .then((res) => {
          console.log("upload", res);
          this.reset();
        })
        .finally(() => {
          this.uploading = false;
          e.target.value = null;
        });
    },

    download() {
      window.open(
        "http://223.75.200.168:38400/api/basic-service/file/iot/盱眙资产台账导入模板.xlsx"
      );
    },

    ...mapActions("userSelector", ["getUserList"]),
      getList() {
          this.loading = true;
          fetchList({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              ...this.form
          })
              .then((res) => {
                  console.log('getList response:', res);
                  this.loading = false;
                  if (Array.isArray(res.list)) {
                      this.list = res.list;
                      this.totalSize = res.totalSize;
                      this.totalPages = res.totalPages;
                  }
              })
              .catch((error) => {
                  console.error('getList error:', error);
                  this.loading = false;
              });
      },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    edit(text) {
      window.localStorage.setItem("materialDetail", JSON.stringify(text));
      this.editShow = true
      this.addShow = false
        this.editKey += 1;
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.logQuery{
    display: flex;
    justify-content: start;
    //width: 80%;
}
.right ::v-deep Button{
    margin: 0 0.2rem;
}
</style>